import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { DisneyLogoRound } from './DisneyLogoRound';

export const DisneyIconModeDesktop = styled(DisneyLogoRound)``;
export const DisneyIconModeMobile = styled(Icon).attrs({ size: 'md' })``;
const disneyIconModeDesktopSelector: string = DisneyIconModeDesktop;
const disneyIconModeMobileSelector: string = DisneyIconModeMobile;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${disneyIconModeDesktopSelector} { display: none; }
        ${disneyIconModeMobileSelector} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${disneyIconModeDesktopSelector} { display: flex; }
        ${disneyIconModeMobileSelector} { display: none; }
    `}
`;
